"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var core_1 = require("@21st-night/core");
var DeckCategoryEditorItem_1 = __importDefault(require("../DeckCategoryEditorItem"));
var DeckCategoryEditorField_1 = __importDefault(require("../DeckCategoryEditorField"));
var DeckCategoryEditorItemContainer = function (_a) {
    var category = _a.category, variant = _a.variant, deck = _a.deck;
    var _b = core_1.useFormField(category), onChange = _b.onChange, value = _b.value;
    var _c = __read(react_1.useState(false), 2), editMode = _c[0], setEditMode = _c[1];
    var handleUpdate = react_1.useCallback(function () {
        if (value) {
            if (variant === 'category') {
                deck.renameCategory(category, value);
            }
            else {
                deck.renameSubcategory(category, value);
            }
        }
        setEditMode(false);
    }, [category, deck, value, variant]);
    var toggleEditMode = react_1.useCallback(function (event) {
        // Prevent toggleDone from being called
        event.stopPropagation();
        setEditMode(!editMode);
    }, [editMode]);
    var handleDelete = react_1.useCallback(function () {
        if (variant === 'category') {
            deck.removeCategory(category);
        }
        else {
            deck.removeSubcategory(category);
        }
    }, [category, deck, variant]);
    if (editMode) {
        return (react_1.default.createElement(DeckCategoryEditorField_1.default, { editMode: true, variant: variant, TextFieldProps: { autoFocus: true }, value: value, onChange: onChange, onSubmit: handleUpdate }));
    }
    return (react_1.default.createElement(DeckCategoryEditorItem_1.default, { category: category, onClickEdit: toggleEditMode, onClickDelete: handleDelete }));
};
exports.default = DeckCategoryEditorItemContainer;
//# sourceMappingURL=DeckCategoryEditorItemContainer.js.map